type IconProps = {
  className?: string
  width?: string | number
  height?: string | number
}

type FillableIconProps = IconProps & {
  fill?: string
}

export const Close = ({ className, height, width }: IconProps) => {
  return (
    <svg
      width={width ?? "18"}
      height={height ?? "18"}
      viewBox="0 0 18 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.33325 2.33337L15.6666 15.6667M15.6666 2.33337L2.33325 15.6667"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
        stroke="currentColor"
      />
    </svg>
  )
}

export const Burger = ({ className, width, height }: FillableIconProps) => {
  return (
    <svg
      width={width ?? "16"}
      height={height ?? "10"}
      viewBox="0 0 16 10"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1 1H15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M1 9H15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const ArrowRight = ({ className, height, width }: IconProps) => (
  <svg
    className={className}
    width={width ?? 28}
    height={height ?? 28}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 13.5714H20.8571"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M17.4286 18.1429L22 13.5714"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M17.4286 9L22 13.5714"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
)
